export default __webpack_public_path__ + "static/media/card-waves.9b8e5aa8.svg";